import { render, staticRenderFns } from "./jmsTXJYRelieveContract.vue?vue&type=template&id=ff9a9420"
import script from "./jmsTXJYRelieveContract.vue?vue&type=script&lang=js"
export * from "./jmsTXJYRelieveContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports